import React, { useState, useEffect } from 'react';
import Panel from './Panel';
import useGlobal from '../../store';
import GiftListCheckbox from '../General/GiftListCheckbox';
import { Button } from 'reactstrap';
import EmailOthersForm from '../Forms/EmailOthersForm';
import LoadingOverlay from '../General/LoadingOverlay';

const ShareLists = (props) => {

    const [isSaving, setIsSaving] = useState(false);
    const [isSending, setIsSending] = useState(false);
    const [showEmailOthers, setShowEmailOthers] = useState(false);
    const [step, setStep] = useState(1);
    const [shareLink, setShareLink] = useState(null);
    const [chosenLists, setChosenLists] = useState([]);

    const [panel, uiActions] = useGlobal(
        state => state.ui.sidepanel,
        actions => actions.uiActions
    );

    const [response] = useGlobal(
        state => state.response
    );

    const [user] = useGlobal(
        state => state.user
    );

    const [giftlists, userActions] = useGlobal(
        state => state.giftlists,
        actions => actions.userActions
    );

    const closePanel = () => {
        uiActions.closeSidePanel();
    }

    const handleInputChange = (event) => {
        console.log('Change', event.target);
        const target = event.target;
        if(target.type !== "checkbox") {
            return;
        }
        if(target.checked) {
            chosenLists.push(target.value);
        } else {
            let idx = chosenLists.indexOf(target.value);
            let newSet = chosenLists;
            newSet.splice(idx, 1);
            setChosenLists(newSet);
        }
    }
    
    const submitShareForm = () => {
        console.log('CREATE SHARE LINK FOR', chosenLists);
        setIsSaving(true);
        let linkData = {
            target_email: null,
            users: chosenLists
        }
        userActions.createSharelink(linkData);
    }

    useEffect(() => {
        if(panel && panel.state) {
            console.log('PANEL', panel.state.users);
            setChosenLists(panel.state.users);
        }
    }, [panel]);

    useEffect(() => {
        if(!response) {
            return;
        }
        if(response.type === "createsharelink") {
            setIsSaving(false);
            setShareLink(response.data.urlCode);
            setStep(2);
        } else if (response.type === "emailsent") {
            setIsSending(false);
            uiActions.createNotification("Ho Ho Ho!", "Email has been sent.");
        }
    }, [response, uiActions]);

    const copyUrl = (() => {
        console.log('copy url');
        const el = document.createElement('textarea');
        el.value = 'https://www.christmaslistapp.com/share/' + shareLink;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        uiActions.createNotification("Copied!", "Share link copied.");

    });

    const emailYourself = () => {
        console.log('email yourself', shareLink);
        if(!shareLink) {
            return;
        }
        setIsSending(true);
        userActions.emailSharelink({
            link_id: shareLink,
            users: chosenLists,
            target_email: user.Email
        });
    };

    const showEmailOthersForm = () => {
        if(!shareLink) {
            return;
        }
        setShowEmailOthers(true);
    };

    const emailOthers = (email) => {
        console.log('email others', email, shareLink);
        if(!shareLink || !email) {
            return;
        }
        setIsSending(true);
        userActions.emailSharelink({
            link_id: shareLink,
            users: chosenLists,
            target_email: email
        });
    };

    const resetShare = () => {
        setStep(1);
        setShowEmailOthers(false);
        setShareLink(null);
        setChosenLists([]);
    }
    const mylist = user ? <GiftListCheckbox checked={panel.state && panel.state.users && panel.state.users.indexOf(user.userID) >=0} handler={handleInputChange} {...user}></GiftListCheckbox> : <></>;
    const nicelist = giftlists.map(gl => <GiftListCheckbox key={gl.userID} checked={panel.state && panel.state.users && panel.state.users.indexOf(gl.userID) >=0} handler={handleInputChange} {...gl}></GiftListCheckbox>);

    return (
        <Panel open={props.open && panel.name === "sharelists"}>
            {props.name === "sharelists" ?
                <>
                <div className="kt-offcanvas-panel__nav bg-white" kt-hidden-height="77">
                    <h3>Share Gift Lists</h3>
                    <button className="kt-offcanvas-panel__close" id="kt_quick_panel_close_btn" onClick={() => closePanel()}><i className="flaticon2-delete"></i></button>
                </div>
                <div className="kt-offcanvas-panel__body content-scroll">
                    { isSending ? <LoadingOverlay></LoadingOverlay> : <></>}
                    { step === 1 ?
                    <div className="tab-content">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" role="tabpanel" >
                            <p>Select the lists you want to share.</p>
                            <div className="kt-checkbox-list p-3">
                                {mylist}
                                {nicelist}
                            </div>
                            <div className="mt-2">
                                <Button className="btn-block btn-info" onClick={() => submitShareForm()}>
                                    Next 
                                    { isSaving ? <span className="ml-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></> }
                                </Button>
                            </div>
                        </div>
                    </div> :
                    <div className="tab-content">
                        <div className="tab-pane fade show kt-offcanvas-panel__content kt-scroll active ps ps--active-y" role="tabpanel" >
                            <h6 className="mb-1">Here's your new share link:</h6>
                            <div>
                                <div className="input-group">
                                    <input type="text" readOnly className="form-control" name="link" value={'https://www.christmaslistapp.com/share/' + shareLink} />
                                    <div className="input-group-append">
                                        <button onClick={() => copyUrl()} className="btn btn-primary" type="button">COPY</button>
                                    </div>
                                </div>
                            </div>
                            <div className="p-3">
                                <p>This link takes people to a special "share page" that only includes the following lists.</p>
                                <ul>
                                    {giftlists.filter(gl => chosenLists.indexOf(gl.userID) >= 0).map(gl => <li key={gl.userID}>{gl.FirstName} {gl.LastName}</li>)}
                                </ul>
                                <p>Copy the URL and send it out any way you'd like, or receive a nicely styled email (for forwarding) or directly email someone else.</p>
                            </div>
                            <div>
                                <Button className="btn-wide btn-info mr-2" onClick={() => emailYourself()}>Email Yourself</Button>
                                <Button className="btn-wide btn-info mr-2" onClick={() => showEmailOthersForm()}>Email Others</Button>
                                
                            </div>

                            {showEmailOthers ? 
                                <div className="mt-2">
                                    <EmailOthersForm handler={emailOthers}></EmailOthersForm>
                                </div>
                                :<></>
                            }
                            <div className="pt-5">
                                <Button className="btn-wide btn-warning" onClick={() => resetShare()}>Share Another List</Button>
                            </div>
                        </div>
                    </div> }

                </div>
                </> : <></>}
        </Panel>

    );
}

export default ShareLists;